import React, { useState, useEffect, useRef, useCallback } from 'react';
import useAuthStore from '../store/authStore';
import {
  IconeHorloge,
} from './IconesSVG';

const INACTIVITE_MAX = 30 * 60 * 1000;      // deconnexion
const AVERTISSEMENT = 25 * 60 * 1000;       // popup 5 minutes avant
const EVENEMENTS = ['click', 'keydown', 'mousemove', 'scroll', 'touchstart'];

// Le motif de deconnexion survit au rechargement : la page de connexion le lit
// puis l'efface, sinon le message reapparaitrait a chaque visite.
export const CLE_MOTIF = 'jeta_motif_deconnexion';

// Surveille l'inactivite et deconnecte au bout de 30 minutes.
// Ne rend rien tant qu'aucun avertissement n'est actif.
export default function ExpirationSession() {
  const { token, logout } = useAuthStore();
  const [avertit, setAvertit] = useState(false);
  const minuteurs = useRef({ avertissement: null, expiration: null });

  const arreter = () => {
    clearTimeout(minuteurs.current.avertissement);
    clearTimeout(minuteurs.current.expiration);
  };

  const expirer = useCallback(() => {
    arreter();
    sessionStorage.setItem(CLE_MOTIF, 'Session expirée, veuillez vous reconnecter');
    logout();
  }, [logout]);

  const relancer = useCallback(() => {
    arreter();
    setAvertit(false);
    minuteurs.current.avertissement = setTimeout(() => setAvertit(true), AVERTISSEMENT);
    minuteurs.current.expiration = setTimeout(expirer, INACTIVITE_MAX);
  }, [expirer]);

  useEffect(() => {
    if (!token) { arreter(); return undefined; }

    relancer();
    // mousemove se declenche en rafale : on ignore les relances rapprochees
    // pour ne pas reprogrammer deux minuteurs a chaque pixel parcouru.
    let dernier = 0;
    const surActivite = () => {
      const maintenant = Date.now();
      if (maintenant - dernier < 1000) return;
      dernier = maintenant;
      relancer();
    };

    EVENEMENTS.forEach((e) => window.addEventListener(e, surActivite, { passive: true }));
    return () => {
      EVENEMENTS.forEach((e) => window.removeEventListener(e, surActivite));
      arreter();
    };
  }, [token, relancer]);

  if (!token || !avertit) return null;

  return (
    <div style={s.fond}>
      <div className="modale-mobile" style={s.boite}>
        <div style={{ marginBottom: 10, color: '#bbb' }}><IconeHorloge taille={34} /></div>
        <div style={s.titre}>Votre session expire dans 5 minutes</div>
        <div style={s.texte}>
          Par sécurité, vous serez déconnecté après 30 minutes d'inactivité.
        </div>
        <div style={{ display: 'flex', gap: 8, marginTop: 20 }}>
          <button type="button" onClick={expirer} style={s.boutonSecondaire}>Se déconnecter</button>
          <button type="button" onClick={relancer} style={s.boutonPrincipal}>Rester connecté</button>
        </div>
      </div>
    </div>
  );
}

const s = {
  fond: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 3000 },
  boite: { background: '#fff', borderRadius: 14, padding: 28, width: 380, textAlign: 'center', boxShadow: '0 10px 40px rgba(0,0,0,0.25)', fontFamily: 'inherit' },
  titre: { fontSize: 16, fontWeight: 800, color: '#0D1B2A', marginBottom: 8 },
  texte: { fontSize: 12.5, color: '#666', lineHeight: 1.5 },
  boutonSecondaire: { flex: 1, padding: '10px', borderRadius: 9, border: '1px solid #ddd', background: '#fff', fontSize: 12, cursor: 'pointer', fontFamily: 'inherit' },
  boutonPrincipal: { flex: 1, padding: '10px', borderRadius: 9, border: 'none', background: '#0D1B2A', color: '#fff', fontSize: 12, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' },
};
